import React from 'react';
import { FormattedMessage } from 'react-intl';
import NextLink from 'next/link';

import { RecommendedArticles as RecommendedArticlesTypes } from '@definitions/articles.types';
import { ROUTE } from '@utils/constants';
import { useImage } from '@hooks/useImage';
import { OptimisedImageWrapper } from '@components/optimisedImageWrapper';

import {
  Container,
  Title,
  ArticlesContainer,
  Link,
  ArticleImage,
  ArticleHeadline,
  ArticleMasthead,
} from './recommendedArticles.styles';

export interface RecommendedArticlesProps {
  articles: RecommendedArticlesTypes[];
}

export interface RecommendedArticleProps {
  article: RecommendedArticlesTypes;
}

const DEFAULT_IMAGE = {
  alt: '',
  title: '',
  urls: [
    { url: '/images/platform.jpeg', size: '1x' },
    { url: '/images/platform.jpeg', size: '2x' },
  ],
};

export const RecommendedArticle = ({ article }: RecommendedArticleProps) => {
  const { slug, image: desktopImage, mobileImage } = article;
  const image = useImage({
    desktopImage: desktopImage || DEFAULT_IMAGE,
    mobileImage: mobileImage || DEFAULT_IMAGE,
  });

  return (
    <a
      onClick={() => {
        window.history.pushState({}, '', `${ROUTE.FEATURES}/${slug}`);
      }}
      href={`${ROUTE.FEATURES}/${slug}`}
    >
      <Link>
        <OptimisedImageWrapper>
          <ArticleImage {...image} />
        </OptimisedImageWrapper>
        <ArticleMasthead>{article.masthead}</ArticleMasthead>
        <ArticleHeadline>{article.headline}</ArticleHeadline>
      </Link>
    </a>
  );
};

export const RecommendedArticles = ({ articles }: RecommendedArticlesProps) => {
  return (
    <Container>
      <Title>
        <FormattedMessage id="recommendedArticles.title" defaultMessage="Read on:" />
      </Title>
      <ArticlesContainer>
        {articles.map((article, index) => (
          <RecommendedArticle article={article} key={index} />
        ))}
      </ArticlesContainer>
    </Container>
  );
};
